export default {
  computed: {
    isSmallScreen: function() {
      return this.$store.getters.isSmallScreen
    },
    isMobile: function() {
      return this.$store.getters.isMobile
    }
  },
  methods: {
    getLongDate: function(day) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      let date = new Date(day);
      return date.toLocaleDateString("fr",options)
    },
    getPhoneLink: function(tel) {
      let toReturn = tel.startsWith('0') ? tel.substring(1) : tel
      return "tel:+33"+toReturn.replace(/\s+/g, '')
    },
    getPhoneTitle: function(title,tel) {
      return `Appeler ${title} au ${tel}`
    },
    getMailLink: function(mail) {
      return "mailto:"+mail
    },
    getMailTitle: function(mail) {
      return `Envoyer un courriel à ${mail} (Fenêtre de messagerie)`
    },
    getTime: function() {
      const date = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' },
      actualDate = new Date()
      
      return `<time datetime="${actualDate.toISOString()}">${actualDate.toLocaleDateString('fr-FR', date)}</time>`
    },
    reFocus: function() {
      if(this.$refs.focusTarget !== undefined) {
        this.$nextTick(() => {
          this.$refs.focusTarget.setAttribute("tabindex",0);
          this.$refs.focusTarget.focus();
        });
      }
    }
  }
}